import { atom } from 'jotai';
import type {LicenseData} from "@/licensing.ts";

export const licenseDataAtom = atom<string | LicenseData | undefined>(undefined);
export const loadingActivationDataAtom = atom<boolean>(false);
export const isDeactivatingAtom = atom<boolean>(false);
export const isActivatingAtom = atom<boolean>(false);
export const hasLoadedLicenseAtom = atom<boolean>(false);
export const licenseErrorAtom = atom<Error | null>(null);

